export default "__VITE_ASSET__BMDJSI41__"